import { Routes } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

import { MainComponent } from './main.component';
import { PageResolver } from './modules/page/page.resolver';
import { NotFoundResolver } from './modules/not-found/not-found.resolver';

export enum MainRoutePath {
  Home = 'home',
  Cart = 'cart',
  Category = 'category',
  Search = 'search/:query',
  Product = 'product',
  Customer = 'customer',
  Kauplused = 'kauplused',
  Teenused = 'teenused',
  Kasulikku = 'kasulikku',
  Uudised = 'uudised',
  ContactUs = 'contact-us',
  Page = 'page/:identifier',
  Notfound = 'notfound',
}

export const MainRoutes: Routes = [
  {
    path: '',
    component: MainComponent,
    providers: [CookieService],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: MainRoutePath.Home,
      },
      {
        path: MainRoutePath.Home,
        loadChildren: () =>
          import('./modules/home/home-page.routing').then((m) => m.HOME_PAGE_ROUTES),
      },
      {
        path: MainRoutePath.Cart,
        loadChildren: () =>
          import('./modules/cart/cart.module').then((m) => m.CartModule),
      },
      {
        path: MainRoutePath.Search,
        loadChildren: () =>
          import('./modules/category/category.module').then((m) => m.CategoryModule),
      },
      {
        path: MainRoutePath.Category,
        loadChildren: () =>
          import('./modules/category/category.module').then((m) => m.CategoryModule),
      },
      {
        path: MainRoutePath.Product,
        loadChildren: () =>
          import('./modules/product/product.routes').then((m) => m.PRODUCT_ROUTES),
      },
      {
        path: MainRoutePath.Customer,
        loadChildren: () =>
          import('./modules/customer/customer-routing.module').then(
            (m) => m.CUSTOMER_ROUTES,
          ),
      },
      {
        path: MainRoutePath.Kauplused,
        loadChildren: () =>
          import('./modules/contacts/contacts.module').then((m) => m.ContactsModule),
      },
      {
        path: MainRoutePath.Teenused,
        loadChildren: () =>
          import('./modules/services/services.module').then((m) => m.ServicesModule),
      },
      {
        path: MainRoutePath.Kasulikku,
        loadChildren: () =>
          import('./modules/useful/useful.module').then((m) => m.UsefulModule),
      },
      {
        path: MainRoutePath.Uudised,
        loadChildren: () =>
          import('./modules/news/news.module').then((m) => m.NewsModule),
      },
      {
        path: MainRoutePath.ContactUs,
        loadChildren: () =>
          import('./modules/contact-page/contact-page.module').then(
            (m) => m.ContactPageModule,
          ),
      },
      {
        path: MainRoutePath.Page,
        loadComponent: () =>
          import('./modules/page/page.component').then((m) => m.PageComponent),
        data: { breadcrumb: 'page' },
        resolve: {
          page: PageResolver,
        },
      },
      {
        path: MainRoutePath.Notfound,
        loadComponent: () =>
          import('./modules/not-found/not-found.component').then(
            (m) => m.NotfoundComponent,
          ),
        data: { breadcrumb: 'notfound' },
        resolve: {
          page: NotFoundResolver,
        },
      },
    ],
  },
];
